module.exports = __webpack_public_path__ + "img/HrmDepartment.bd95df21.svg";